import { useEffect, useState } from 'react';
import { RouteObject } from 'react-router-dom';

import { getMfRoutes } from './getMfRoutes';

export function useMfRoutes(mfName: string) {
  const [routes, setRoutes] = useState<RouteObject[] | undefined>();

  useEffect(() => {
    let active = true;
    if (mfName) {
      (async () => {
        try {
          const ro = await getMfRoutes(mfName);
          if (active) {
            setRoutes(ro);
          }
        } catch (error) {
          // Log error but keep the loading state
          console.error('Failed to load routes:', error);
          if (active) {
            setRoutes(undefined);
          }
        }
      })();
    }
    return () => {
      active = false;
    };
  }, [mfName]);

  return routes;
}
